import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Redirect beta URLs to their canonical equivalents before Angular boots.
// beta.growthemr.com  →  devemr.growthemr.com  (dev / EMR env)
// beta.growth99.com   →  app.growth99.com       (production env)
const BETA_REDIRECT_MAP: Record<string, string> = {
  'beta.growthemr.com': 'devemr.growthemr.com',
  'beta.growth99.com': 'app.growth99.com',
};

const currentHostname = window.location.hostname;
const targetHostname = BETA_REDIRECT_MAP[currentHostname];

if (targetHostname) {
  const url = new URL(window.location.href);
  url.hostname = targetHostname;
  window.location.replace(url.toString());
} else {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
  );
}
